import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "full-container" }
const _hoisted_2 = { class: "header-menu-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "width60px" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "width60px" }, null, -1)
const _hoisted_6 = { class: "body-container" }
const _hoisted_7 = {
  key: 0,
  class: "vertical-menu-container"
}
const _hoisted_8 = { class: "flex1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_list = _resolveComponent("select-list")
  const _component_text_popover = _resolveComponent("text-popover")
  const _component_horizontal = _resolveComponent("horizontal")
  const _component_vertical = _resolveComponent("vertical")
  const _component_subvertical = _resolveComponent("subvertical")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_coupon_details = _resolveComponent("coupon-details")
  const _component_password_dialog = _resolveComponent("password-dialog")
  const _component_set_time_zone_dialog = _resolveComponent("set-time-zone-dialog")
  const _component_billing_dialog = _resolveComponent("billing-dialog")
  const _component_customer_dialog = _resolveComponent("customer-dialog")
  const _component_account_setting_dialog = _resolveComponent("account-setting-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_horizontal, {
      onLogOut: _ctx.goBackLogin,
      "home-url": _ctx.homeUrl,
      showLogo: _ctx.activeIndex != _ctx.activeName
    }, {
      default: _withCtx(() => [
        _createVNode("header", _hoisted_2, [
          _hoisted_3,
          (_ctx.isSpecial)
            ? (_openBlock(), _createBlock(_component_text_popover, {
                key: 0,
                name: _ctx.$wordList.TabelUserInHtmlRoleLabel+':'+_ctx.installerRole.label,
                isShow: _ctx.controlPopVal['role'],
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideOtherPop(Boolean($event), 'role')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_list, {
                    list: _ctx.InstallerType,
                    active: String(_ctx.activeRole),
                    onChangeSelect: _ctx.changeInstaller
                  }, null, 8, ["list", "active", "onChangeSelect"])
                ]),
                _: 1
              }, 8, ["name", "isShow"]))
            : _createCommentVNode("", true),
          _hoisted_4,
          (_ctx.isShowCommunityList)
            ? (_openBlock(), _createBlock(_component_text_popover, {
                key: 1,
                name: _ctx.communityName,
                isShow: _ctx.controlPopVal['community'],
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideOtherPop(Boolean($event), 'community')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_list, {
                    list: _ctx.CommunityList,
                    onChangeSelect: _ctx.changeCommunity
                  }, null, 8, ["list", "onChangeSelect"])
                ]),
                _: 1
              }, 8, ["name", "isShow"]))
            : _createCommentVNode("", true),
          _hoisted_5,
          (_ctx.isDisLogin)
            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(_ctx.accountName), 1)
              ], 64))
            : (_openBlock(), _createBlock(_component_text_popover, {
                key: 3,
                name: _ctx.accountName,
                isShow: _ctx.controlPopVal['account'],
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideOtherPop(Boolean($event), 'account')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_list, {
                    list: _ctx.userList,
                    onChangeSelect: _ctx.chooseOpera
                  }, null, 8, ["list", "onChangeSelect"])
                ]),
                _: 1
              }, 8, ["name", "isShow"]))
        ])
      ]),
      _: 1
    }, 8, ["onLogOut", "home-url", "showLogo"]),
    _createVNode("section", _hoisted_6, [
      (_ctx.activeIndex !== _ctx.activeName)
        ? (_openBlock(), _createBlock("aside", _hoisted_7, [
            _createVNode(_component_el_scrollbar, { "view-style": "overflow-x: hidden;" }, {
              default: _withCtx(() => [
                _createVNode(_component_vertical, { menus: _ctx.menus }, null, 8, ["menus"]),
                _withDirectives(_createVNode(_component_subvertical, {
                  submain: _ctx.submain,
                  submenus: _ctx.submenus
                }, null, 8, ["submain", "submenus"]), [
                  [_vShow, _ctx.isShowToolBox == 1]
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("section", _hoisted_8, [
        _createVNode(_component_router_view, {
          key: _ctx.$route.fullPath
        })
      ])
    ]),
    (_ctx.isShowCouponDetails)
      ? (_openBlock(), _createBlock(_component_coupon_details, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowCouponDetails = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowPasswordDialog)
      ? (_openBlock(), _createBlock(_component_password_dialog, {
          key: 1,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowPasswordDialog = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowTimeZoneDialog)
      ? (_openBlock(), _createBlock(_component_set_time_zone_dialog, {
          key: 2,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowTimeZoneDialog = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowBillingDialog)
      ? (_openBlock(), _createBlock(_component_billing_dialog, {
          key: 3,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowBillingDialog = false)),
          userType: "installer"
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowCustomerDialog)
      ? (_openBlock(), _createBlock(_component_customer_dialog, {
          key: 4,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowCustomerDialog = false)),
          userType: "installer"
        }))
      : _createCommentVNode("", true),
    (_ctx.isShowAccountSettingDialog)
      ? (_openBlock(), _createBlock(_component_account_setting_dialog, {
          key: 5,
          "init-form": _ctx.pwFreeConfig,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowAccountSettingDialog=false)),
          onSuccess: _ctx.getPwFreeConfig
        }, null, 8, ["init-form", "onSuccess"]))
      : _createCommentVNode("", true)
  ]))
}